import React from 'react'
import HouseholdsComponent from '../Components/HouseholdComponent'

const HouseholdsPage = () => {
  return (
    <HouseholdsComponent />
  )
}

export default HouseholdsPage